import { render, staticRenderFns } from "./OverviewTabs.vue?vue&type=template&id=60369fbe&scoped=true"
import script from "./OverviewTabs.vue?vue&type=script&lang=js"
export * from "./OverviewTabs.vue?vue&type=script&lang=js"
import style0 from "./OverviewTabs.vue?vue&type=style&index=0&id=60369fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60369fbe",
  null
  
)

export default component.exports